export default __webpack_public_path__ + "static/media/monofocales_desktop.6cdd60ac.svg";